import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyStatusBanner = loadable(() => import(/* webpackChunkName: "content/guest/site/statusbanner" */ './StatusBanner'), 'StatusBanner');
